if ($.magnificPopup) {
    $.extend(true, $.magnificPopup.defaults, {
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
    });
    
    $('.js-popup-video').magnificPopup({
        type: 'iframe',
        iframe: {
            patterns: {
                youtube: {
                    index: 'youtube.com/',
                    id: 'v=',
                    src: '//www.youtube.com/embed/%id%?modestbranding=1&controls=0&autoplay=1&rel=0&enablejsapi=1',
                },
            },
        },
        callbacks: {
            open: () => {
                if ('ytTracker' in window) {
                    window.ytTracker.init();
                }
            },
        },
    });
    
    $('.js-popup-gallery').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true,
        },
    });

}
